const scene = "coupon/";

export const UPDATE_COUPON = `${scene}UPDATE_COUPON`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
